import axios from 'axios';

import getAuthSession from './auth';
import { BestPracticeStatus } from '../interfaces/survey.interface';

export default async function createBestPracticeStatus(bestPracticeStatus: BestPracticeStatus) {
  const authSession = await getAuthSession();
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_API}/best-practice-statuses/`,
    {
      bestPractice: typeof bestPracticeStatus.bestPractice === 'number' ? bestPracticeStatus.bestPractice : bestPracticeStatus.bestPractice.id,
      color: bestPracticeStatus.color,
      questionsAnsweredCount: bestPracticeStatus.questionsAnsweredCount,
      visibleQuestionsCount: bestPracticeStatus.visibleQuestionsCount,
      status: bestPracticeStatus.status,
    },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as BestPracticeStatus;
}

export async function updateBestPracticeStatus(bestPracticeStatus: BestPracticeStatus) {
  const authSession = await getAuthSession();
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_API}/best-practice-statuses/${bestPracticeStatus.id}/`,
    {
      id: bestPracticeStatus.id,
      bestPractice: typeof bestPracticeStatus.bestPractice === 'number' ? bestPracticeStatus.bestPractice : bestPracticeStatus.bestPractice.id,
      color: bestPracticeStatus.color,
      questionsAnsweredCount: bestPracticeStatus.questionsAnsweredCount,
      visibleQuestionsCount: bestPracticeStatus.visibleQuestionsCount,
      status: bestPracticeStatus.status,
    },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as BestPracticeStatus;
}

export async function deleteBestPracticeStatus(bestPracticeStatus: BestPracticeStatus) {
  const authSession = await getAuthSession();
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_API}/best-practice-statuses/${bestPracticeStatus.id}/`,
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data;
}

// One atomic bulk-create instead of a per-BP Promise.all fan-out that partial-failed and left surveys at [] (TPE-2942).
export const createBulkBestPracticeStatuses = async (survey: number, bestPracticeStatuses: BestPracticeStatus[]) => {
  const authSession = await getAuthSession();
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_API}/best-practice-statuses/bulk-create/`,
    {
      survey,
      bestPracticeStatuses: bestPracticeStatuses.map(bestPracticeStatus => ({
        bestPractice: typeof bestPracticeStatus.bestPractice === 'number' ? bestPracticeStatus.bestPractice : bestPracticeStatus.bestPractice.id,
        color: bestPracticeStatus.color,
        questionsAnsweredCount: bestPracticeStatus.questionsAnsweredCount,
        visibleQuestionsCount: bestPracticeStatus.visibleQuestionsCount,
        status: bestPracticeStatus.status,
      })),
    },
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as BestPracticeStatus[];
};